import { REACT_APP_KINASTIC_ENVIRONMENT } from '../Config/environment';

const __DEV__ = !REACT_APP_KINASTIC_ENVIRONMENT;
export const __BETA__ = REACT_APP_KINASTIC_ENVIRONMENT === 'beta';
export const __PRODUCTION__ = REACT_APP_KINASTIC_ENVIRONMENT === 'production';

export default __DEV__;
